import { render, staticRenderFns } from "./ContentLabelReview.vue?vue&type=template&id=425acff3&"
import script from "./ContentLabelReview.vue?vue&type=script&lang=js&"
export * from "./ContentLabelReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports